import { HomePage } from "@/pages/HomePage";
import {
  ApplicationViewOption,
  applicationViewOptions,
  DeviceFilterOption,
  deviceFilterOptions,
  RenderModeFilterOption,
  renderModeFilterOptions,
} from "@/search/filters";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

const defaultValues: {
  device: DeviceFilterOption;
  "render-mode": RenderModeFilterOption;
  view: ApplicationViewOption;
} = {
  device: "all",
  "render-mode": "all",
  view: "categories",
};

const homePageQueryParamsSchema = z.object({
  device: z.enum(deviceFilterOptions).optional().default(defaultValues.device),
  "render-mode": z
    .enum(renderModeFilterOptions)
    .optional()
    .default(defaultValues["render-mode"]),
  view: z.enum(applicationViewOptions).optional().default(defaultValues.view),
});

export const Route = createFileRoute("/_authenticated/_layout/_main/")({
  validateSearch: homePageQueryParamsSchema,
  component: HomePage,
  search: {
    // strip default values
    middlewares: [stripSearchParams(defaultValues)],
  },
});
